import { render, staticRenderFns } from "./NavigationItemSubmenu.vue?vue&type=template&id=2429ce48&"
import script from "./NavigationItemSubmenu.vue?vue&type=script&lang=js&"
export * from "./NavigationItemSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports